// extracted by mini-css-extract-plugin
module.exports = {"btnAction":"ButtonAction_btnAction__3RQ-w"};